// About.js
import React from 'react';
import './About.css';  // You'll need to create this CSS file
import { MdSmartToy, MdNotifications, MdPhonelink } from 'react-icons/md';
import { FaMoneyBillWave, FaLeaf, FaTools, FaSeedling } from 'react-icons/fa';

const About = () => {
  return (
    <div className="about-container">
      <h1>Why Choose Us?🌿🌿🌿</h1>

      <div className="features-grid">
        <div className="feature-item">
          <div className="feature-content">
            <h3>Smart & Accurate Monitoring</h3>
          </div>
          <div className="feature-icon">
            <MdSmartToy />
          </div>
        </div>

        <div className="feature-item">
          <div className="feature-content">
            <h3>Automated Water Reminders</h3>
          </div>
          <div className="feature-icon">
            <MdNotifications />
          </div>
        </div>
        <div className="feature-item">
          <div className="feature-content">
            <h3>Easy Setup & User-Friendly</h3>
          </div>
          <div className="feature-icon">
            <FaTools />
          </div>
        </div>
        <div className="feature-item">
          <div className="feature-content">
            <h3>Cost-Effective Solution</h3>
          </div>
          <div className="feature-icon">
            <FaMoneyBillWave />
          </div>
        </div>
        <div className="feature-item">
          <div className="feature-content">
            <h3>Eco-Friendly & Sustainable</h3>
          </div>
          <div className="feature-icon">
            <FaLeaf />
          </div>
        </div>


        <div className="feature-item">
          <div className="feature-content">
            <h3>Empower Your Plants with Smart Care</h3>
          </div>
          <div className="feature-icon">
            <FaSeedling />
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;